window.sq = window.sq || {};
window.sq.onSearchInit = function (query) {

        try{

let filterQuery = query;
        
if(filterQuery){

query.filter = query.filter.replace('AND in_stock = 1','')
}  
  return query;
}catch(e){}    

}